<template>
<div>
	<wrapper-edit
      :wrapper-width="wrapperWidth"
      @back="paasPageBack">
    <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth">
       <Row>
         <FormItem label="会员号：" prop="userCode" class="ivu-col-span-8" >
               <Input v-model="paasFormData.userCode" clearable ></Input>
         </FormItem>
         <FormItem label="昵称：" prop="nickname" class="ivu-col-span-8" >
            <Input v-model="paasFormData.nickname"  clearable ></Input>
         </FormItem>
          <FormItem label="真实姓名：" prop="realName" class="ivu-col-span-8" >
               <Input v-model="paasFormData.realName"  clearable ></Input>
          </FormItem>
       </Row>
      <Row>
          <FormItem label="手机号：" prop="phone" class="ivu-col-span-8" >
              <Input v-model="paasFormData.phone" clearable ></Input>
          </FormItem>
          <FormItem label="生日：" prop="birthday" class="ivu-col-span-8" >
              <DatePicker type="datetime" format="yyyy-MM-dd" v-model="paasFormData.birthday" confirm clearable></DatePicker >
          </FormItem>
          <FormItem label="性别：" prop="gender" class="ivu-col-span-8" >
              <Enum :enumJsonKey="'crmdict-gender'"  v-model="paasFormData.gender"  type="radio" ></Enum>
          </FormItem>
      </Row>
      <Row>
          <FormItem label="国家：" prop="country" class="ivu-col-span-8" >
              <Input v-model="paasFormData.country" clearable ></Input>
          </FormItem>
          <FormItem label="省份：" prop="province" class="ivu-col-span-8" >
              <Input v-model="paasFormData.province" clearable ></Input>
          </FormItem>
          <FormItem label="城市：" prop="city" class="ivu-col-span-8" >
              <Input v-model="paasFormData.city" clearable ></Input>
          </FormItem>
      </Row>
       <Row>
           <FormItem label="详细地址：" prop="address" class="ivu-col-span-24" >
               <Input v-model="paasFormData.address" clearable ></Input>
           </FormItem>
       </Row>
       <Row>
           <FormItem label="可用积分：" prop="integral" class="ivu-col-span-8" >
               <Input v-model="paasFormData.integral" readonly></Input>
           </FormItem>
           <FormItem label="可用余额：" prop="nowMoney" class="ivu-col-span-8" >
               <Input v-model="paasFormData.nowMoney"  readonly></Input>
           </FormItem>
           <FormItem label="佣金余额：" prop="brokeragePrice" class="ivu-col-span-8" >
               <Input v-model="paasFormData.brokeragePrice"  readonly></Input>
           </FormItem>
       </Row>
        <Row>
            <FormItem label="会员等级：" prop="level" class="ivu-col-span-5" >
                <Input v-model="paasFormData.level"  readonly></Input>
            </FormItem>
            <FormItem label="是否为推广员：" prop="isPromoter" class="ivu-col-span-11" >
                <Enum :enumJsonKey="'crmdict-isPromoter'"  v-model="paasFormData.isPromoter"  type="radio" ></Enum>
            </FormItem>
            <FormItem label="启用状态：" prop="status" class="ivu-col-span-8" >
                <Enum :enumJsonKey="'crmdict-userStatus'"  v-model="paasFormData.status"  type="radio" ></Enum>
            </FormItem>
        </Row>
       <Row>
         <FormItem label="用户备注：" prop="mark" class="ivu-col-span-24" >
          <Input v-model="paasFormData.mark"  type="textarea"  clearable ></Input>
         </FormItem>
       </Row>

       <div class="edit-oper-toolbar">
	      <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
	      <Button @click="paasFormSubmit('paasForm','','userList')" style="margin-left: 8px">保存并返回</Button>
	      <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
	    </div>  
    </Form>  
      
    </wrapper-edit>
</div>
</template>
<script>
import wrapperEdit from "@/components/paas/wrapper-edit";
import metaEdit from "@/assets/js/meta-edit.js";
import Enum from '@/components/paas/enum-form' //枚举渲染
 
export default {
   name: "edit",
   mixins:[metaEdit],
   components:{wrapperEdit,Enum},
   data(){
     return {
     	serviceUrl:"/eb/user",  //每个页面访问后台服务器的路径
      currentIdFiledName: 'uid',
      defaultLabelWidth:'140',
      paasFormData:{
        	id:'',
            userCode:"",
        	account:'', // 用户账号
        	nickname:'',
        	realName:'',
        	status:'',
        	addIp:'',
        	partnerId:'',
        	groupId:'',
        	phone:'',// 手机号码
        	lastIp:'',
            level:'',
        	payCount:'',
        	spreadCount:'',
        	avatar:'', // 用户头像
        	cardId:'',// 身份证号码
        	integral:'',
        	spreadUid:'',
        	mark:'',
        	nowMoney:'',
        	isPromoter:'',
        	lastTime:'',
        	addTime:'',
        	brokeragePrice:'',
        	birthday:'',
        	pwd:'',
        	cleanTime:'',
        	adminid:'',
        	loginType:'',
        	userType:'',
        	signNum:'',
            address:'',
        	spreadTime:'',
            openid:'',
            gender:'',
            country:'',
            province:'',
            city:'',
            spreadName:'',
          newUserCouponStatus:"",
          levelId:"",
          promoterQrCode:"",
          unionid:""

        },
        paasFormRules:{

        },
        redirectName:"ebUserList",
        nextAddName:"ebUserEdit",
    }
   },
   methods:{
     createdCallback(data) {
       console.log(data);
     },
   }
}
</script>
